import React, { useState, useEffect } from 'react'
import { Badge, Col, Row, Table } from 'reactstrap';
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import { toThaiDate } from "../../../helpers/date_helper"
import axios from "axios";
import { FetchAxiosGet } from '../../../api/axios';
import dayjs from 'dayjs';

const ResorceOnline = () => {

  const API_URL = process.env.REACT_APP_API_CORS;
  const [data, setData] = useState([]);
  const [listEquipment, setListEquipment] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");

  const checkLateReturn = (status, date_return) => {
    return (<Badge
              pill
              color={
                status === 0
                  ? "primary"
                  : status === 1
                  ? "success"
                  : status === 2
                  ? "secondary"
                  : status === 3
                  ? "danger"
                  : status === "late"
                  && "warning"
              }
            >
              {
                status === 0
                    ? "จองแล้ว"
                    : status === 1
                    ? "รับแล้ว"
                    : status === 2
                    ? "คืนแล้ว"
                    : status === 3
                    ? "ไม่อนุมัติ"
                    : status === "late"
                    && "เกินกำหนด"
              }
            </Badge>)
   }

  const fetchData = async () => {
    let url = `${API_URL}/api/borrow/equipment/datatable`;
    let params = new URLSearchParams({
      page: 1, size: 5,
      "order[0]": "id", "order[1]": "DESC",
      "filter[users_id_borrow][0]": user?.user_id,
      // "filter[status][0]": 1
    });
    const config = { headers: { Authorization: `Bearer ${token}`, }, params };

    await axios.get(url, config).then(async response => {
      await setData(response.data.result);
    }).catch(error => console.error("Error:", error));
  };

  useEffect(() => {
    const thisEffect = async () => {
      await setLoading(true);
      await fetchData();
      setTimeout(async() => {
        await setLoading(false)
      }, 1500);
    }
    thisEffect();
  }, []);

  useEffect(() => {
    const thisEffect = async () => {

      if (data.length > 0) {

        const equipment = data.map((x, i) => x?.equipment_id);
        const eqmO = {};
        for await (const [ind, val] of Object.entries(equipment)) {
          eqmO[`filter[item_id][${ind}]`] = val
        }
        const url = `${API_URL}/api/equipment/datatable`;
        const params = new URLSearchParams({
          page: 1, size: 5,
          "order[0]": "item_id", "order[1]": "DESC",
          ...eqmO
        });
        const config = { headers: { Authorization: `Bearer ${token}`, }, params };
        await axios.get(url, config).then(async response => {
          setListEquipment(response.data.result);
        }).catch(error => console.error("Error:", error));
        // await setLoading(false);

      }

    }
    thisEffect();
  }, [data]);

  const showDateAndTime = (dateItem) => {
    return `${dayjs.utc(dateItem).add(543,"year").format("DD/MM/YYYY")}  ${dayjs.utc(dateItem).format("HH:mm")}`
   }

  return (
    <React.Fragment>
      <Row style={{ display: "flex", alignItems: "center" }} className="mt-3">
        <Col xs={12}>
          <h5>ตารางแสดงข้อมูลการยืมครุภัณฑ์</h5>
        </Col>
        <Col className="text-end"></Col>
      </Row>
      <div class="my-2" style={{ border: '2px solid rgb(58, 64, 205)' }}></div>
      <Row>
        <Col>
          <div style={{ overflowX: "scroll", whiteSpace: "nowrap" }}>
            <Table striped hover className="mt-2">
              <thead className="table-primary">
                <tr>
                  {/* <th className='w-75'>ชื่อครุภัณฑ์และรหัสครุภัณฑ์</th>
                  <th className='text-center'>วันที่ยืม</th>
                  <th className='text-center'>วันที่คืน</th>
                  <th className='text-center'>สถานะ</th> */}
                  <th>ชื่อครุภัณฑ์</th>
                  <th>ประเภทครุภัณฑ์</th>
                  <th className="text-center">วันและเวลาที่ยืม</th>
                  <th className="text-center">วันและเวลาที่คืน</th>
                  <th className="text-center">เพื่อใช้งาน</th>
                  <th className="text-center">สถานะ</th>
                  <th>ผู้ยืม</th>
                </tr>
              </thead>
              <tbody className="table-light">
                {(data.length > 0 && loading === false)
                  ?
                  data.map((item, idx) => {
                    return (
                      <tr key={idx}>
                        {/* <td>
                          <label className="m-0">{listEquipment.find(x => parseInt(x.item_id) === parseInt(item?.equipment_id))?.detail}</label>
                          <br />
                          <label className="m-0 text-muted">{listEquipment.find(x => parseInt(x.item_id) === parseInt(item?.equipment_id))?.item_format}</label>
                        </td>
                        <td className='text-center'>{toThaiDate(item?.date_borrow, true)}
                        </td>
                        <td className='text-center'>{toThaiDate(item?.date_return, true)}</td>
                        <td className='text-center'>{checkLateReturn(new Date() > new Date(item?.date_return) && item?.status === 1 ? "late" : item?.status, item?.date_return)}</td> */}
                      
                        <td><label className="m-0">{listEquipment.find(x => parseInt(x.item_id) === parseInt(item?.equipment_id))?.detail}</label></td>
                        <td>{listEquipment.find(x => parseInt(x.item_id) === parseInt(item?.equipment_id))?.type_name}</td>
                        <td className="text-center">{showDateAndTime(item.date_borrow)}</td>
                        <td className="text-center">{showDateAndTime(item.date_return)}</td>
                        <td className="text-center">{item.remark_borrow ?? ""}</td>
                        <td className="text-center font-size-16">{checkLateReturn(new Date() > new Date(item.date_return) && item.status === 1 ? "late" : item.status, item.date_return)}</td>
                        <td>{item.users_name_borrow}</td>
                      
                      </tr>
                    );
                  })
                  :
                  <tr key={'1'}>
                    <td className="text-center" colSpan={7}>
                      {loading ? <i class="fa-duotone fa-spinner-third fa-spin"></i> : 'ไม่พบข้อมูล'}
                    </td>
                  </tr>}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default ResorceOnline